import React, {Component} from 'react';

export class Utils extends Component {

    static PHI = (1 + Math.sqrt(5)) / 2;

    static shuffle(list) {
        return list.map((a) => ({sort: Math.random(), value: a}))
            .sort((a, b) => a.sort - b.sort)
            .map((a) => a.value)
    }

    static outline = (text, color, fill) => {
        const style = {
            color: fill,
            textShadow: [
                '-0.15rem 0 0 ' + color,
                '0.15rem 0 0 ' + color,
                '0 -0.15rem 0 ' + color,
                '0 0.15rem 0 ' + color,
                '-0.1rem -0.1rem 0.15rem ' + color,
                '0.1rem -0.1rem 0.15rem ' + color,
                '-0.1rem 0.1rem 0.15rem ' + color,
                '0.1rem 0.1rem 0.15rem ' + color]
        }
        return <span style={style}>{text}</span>
    }

    static download_json = (json, name) => {
        const element = document.createElement("a");
        const textFile = new Blob([Utils.json_str(json)]);
        element.href = URL.createObjectURL(textFile);
        element.download = name + ".json";
        document.body.appendChild(element);
        element.click();
    }

    static json_str = (json) => {
        return JSON.stringify(json, undefined, 2)
    }

    static random_int = (limit = 100000) => {
        return Math.floor(Math.random() * limit);
    }

    static random_id = (limit = 100000) => {
        return 'id_' + Math.floor(Math.random() * limit);
    }

    static dot_char = () => {
        return String.fromCharCode(183)
    }

    static animate = (ref, duration_ms, start_value, end_value, fn, not_count = 10) => {
        const count = Math.floor(duration_ms / 40) + 2;
        const time_slice = duration_ms / count;
        const value_delta = (end_value - start_value) / count;
        let so_far = 0;
        const interval = setInterval(() => {
            const value = start_value + so_far * value_delta;
            if (!ref.current) {
                console.log("animate, ref.current is null")
                clearInterval(interval);
                return;
            } else {
                fn(value, so_far === count);
            }
            if (so_far === count) {
                clearInterval(interval);
                return;
            }
            so_far++;
        }, time_slice);
        return interval;
    }

}

export default Utils;
